import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import AppNavbar from "../components/common/AppNavbar";

const tocItems = [
  { id: "privacy-notice", label: "1. Privacy Notice" },
  { id: "information-gathering", label: "2. What Information We Gather" },
  { id: "gdpr-rights", label: "3. GDPR Rights (EU Residents)" },
  { id: "ccpa-rights", label: "4. CCPA Rights (California Residents)" },
  { id: "data-usage", label: "5. How Data is Used" },
  { id: "iba", label: "6. Interest-Based Advertising" },
  { id: "ad-sponsors", label: "7. Ad Sponsors & Advertisers" },
  { id: "retention", label: "8. Retention & Storage" },
  { id: "security", label: "9. Security of Information" },
  { id: "cookies", label: "10. Why We Use Cookies" },
  { id: "changes", label: "11. Changes to Privacy Policy" },
  { id: "contact", label: "12. Contact Us" },
];

const sectionContent = {
  "privacy-notice": `We encourage you to read this Privacy Policy in its entirety to understand the information we collect and how we use and disclose it. Thank you for visiting BharatAbroad website. BharatAbroad appreciates your interest in our company and services we offer. By visiting our website, you are accepting the Privacy Policy of use and Terms and Conditions in any other manner.`,

  "information-gathering": `We gather both anonymous and personally identifiable information. This includes First/Last Name, Email (when subscribing to mailing lists or applying for jobs), IP address, ISP information, date/time stamp, and click stream data. This information is used to improve user experience and develop products and services.`,

  "gdpr-rights": `If you are a resident of the EU, you have the following rights under GDPR:
- The right to be informed
- The right of access
- The right to rectification
- The right to erasure
- The right to restrict processing
- The right to data portability
- The right to object
- Rights in relation to automated decision making and profiling.`,

  "ccpa-rights": `If you are a resident of California, your rights under CCPA include:
- The right to access personal information a business holds
- The right to know what personal data will be collected before collection
- The right to opt in or out of marketing, analytics, and similar activities
- The right to equal services without discrimination
- The right to request deletion of personal data.`,

  "data-usage": `We do not sell your personal data. Information collected is used to:
- Provide requested services
- Send relevant communications
- Analyze site usage and improve content
- Detect and prevent malicious attacks.`,

  iba: `BharatAbroad participates in Interest-Based Advertising (IBA). Data is collected from your online activity (via cookies, pixel tags, etc.) to show ads that may interest you. To opt out of IBA, visit http://www.aboutads.info/choices/ or http://www.networkadvertising.org/choices/.`,

  "ad-sponsors": `Advertisers may promote products/services on BharatAbroad. Ads must comply with laws, policies, and appropriate content guidelines.`,

  retention: `We retain information as long as necessary for legitimate business needs or legal compliance. Data may be shared with government agencies if required by law. Data is governed by U.S. law.`,

  security: `We take reasonable measures to secure collected data. However, no internet transmission or storage is 100% secure, and we cannot guarantee absolute protection.`,

  cookies: `Cookies are used to personalize and improve user experience. They help us recognize and remember users across sessions. Please see our Cookie Policy for details.`,

  changes: `This Privacy Policy was revised on February 6, 2023. It may be amended from time to time. Users should check back for the most current version.`,

  contact: `If you have any questions or concerns, please contact us at info@BharatAbroad.com`,
};

const PrivacyPolicy = () => {
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const offset = 100;
      for (let i = tocItems.length - 1; i >= 0; i--) {
        const section = document.getElementById(tocItems[i].id);
        if (section && window.scrollY + offset >= section.offsetTop) {
          setActiveId(tocItems[i].id);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const renderContent = (content) => {
    const lines = content
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
    const isList = lines.every((line) => line.startsWith("-"));

    if (isList) {
      return (
        <ul>
          {lines.map((line, idx) => (
            <li key={idx}>{line.replace(/^-/, "").trim()}</li>
          ))}
        </ul>
      );
    }

    return lines.map((line, idx) => (
      <p key={idx} className="text-muted" style={{ whiteSpace: "pre-line" }}>
        {line}
      </p>
    ));
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-white">
      <AppNavbar />
      <Container
        fluid
        className="py-5 px-3 px-lg-5"
        style={{ maxWidth: "1400px" }}
      >
        <Row>
          <Col lg={9}>
            <h3 className="fw-bold  mb-2">Privacy Policy – BharatAbroad</h3>
            <p className="text-muted mb-5">Last updated Aug 15, 2025</p>

            {tocItems.map(({ id, label }) => (
              <section className="mb-4" id={id} key={id}>
                <h5 className="fw-bold mb-2">{label}</h5>
                {renderContent(sectionContent[id])}
              </section>
            ))}
          </Col>

          <Col lg={3} className="d-none d-lg-block">
            <div className="sticky-top pt-2" style={{ top: "100px" }}>
              <h6 className="text-dark mb-3 fw-bold">Table of contents</h6>
              <ul className="list-unstyled small">
                {tocItems.map(({ id, label }) => (
                  <li className="mb-2" key={id}>
                    <a
                      href={`#${id}`}
                      className={`text-decoration-none ${
                        activeId === id
                          ? "text-primary fw-semibold"
                          : "text-muted"
                      }`}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
              <a href="#top" className="text-muted small d-block mt-3">
                ⬆ Back to top
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
